export default "__VITE_ASSET__lsJOFBIz__"